<template>
  <div id="main">
    <router-view />
  </div>
</template>

<script>
import { serverBus } from "@/main";

export default {
  name: "app",

  created() {
    localStorage.setItem("skin", "skin-blue");
    serverBus.$on("globalNotification", (e) => {
      this.$toasted.show(e.m, {
        position: "top-right",
        duration: 5000,
        type: e.type || "error",
        closeOnSwipe: true
      });
    });
  }
};
</script>
